import { render, staticRenderFns } from "./PopupEditCompany.vue?vue&type=template&id=6c51478e&scoped=true"
import script from "./PopupEditCompany.vue?vue&type=script&lang=js"
export * from "./PopupEditCompany.vue?vue&type=script&lang=js"
import style0 from "./PopupEditCompany.vue?vue&type=style&index=0&id=6c51478e&prod&lang=css"
import style1 from "./PopupEditCompany.vue?vue&type=style&index=1&id=6c51478e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c51478e",
  null
  
)

export default component.exports